import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Subject, takeUntil } from 'rxjs';
import { LoaderComponent } from '@equine-ui-nx/ui';

@Component({
  selector: 'app-callback',
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.scss'],
  imports: [MatProgressSpinnerModule, LoaderComponent],
  standalone: true,
  // providers: [AuthService]
})
export class CallbackComponent {
  public token: any;
  unsubscribe$ = new Subject<boolean>();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private snackBar: MatSnackBar
  ) {

    // If one day the query is so big that is not allowed use navigate(..., {state}) and here:
    // this.token = this.router.getCurrentNavigation()?.extras.state;
    this.authService.cleanLocalStorage();

    this.token = this.route.snapshot.queryParams;

    if (this.token['accessToken'] && this.token['refreshToken']) {
      this.authService
        .verifyToken({
          accessToken: this.token['accessToken'],
          refreshToken: this.token['refreshToken'],
          appName: route.snapshot.data["appName"]
        })
        .subscribe(
          {
            next: (data: any) => {
              const tokenInfo = data['data'];
              const user = JSON.parse(this.token['userDataString'])
              authService.emitLoggedinUser(user)
              this.authService.decodeAccessToken();
              this.authService.setIsUserLogin(true);
              this.setTokensIntoStorage(
                tokenInfo.accessToken,
                tokenInfo.refreshToken,
                this.token['userDataString']
              );
              const selectedSeason = this.token["selectedSeason"] ? JSON.parse(this.token["selectedSeason"]) : null;
              if(selectedSeason && Object.keys(selectedSeason).length) {
                localStorage.setItem('selectedSeason', JSON.stringify(selectedSeason));
              }
              if(data["data"].oboUser) {
                this.authService.setSeasonSelectionConfirmation(true);
              }
              let redirectUrl = route.snapshot.data['redirectUrl'];
              const requestedUrl = authService.getRequestedUrl()
              if(requestedUrl) {
                redirectUrl = requestedUrl
              }
              router.navigateByUrl(redirectUrl);
            },
            error: (err) => {
              this.snackBar.open('Invalid URL!', 'close', { duration: 5000, panelClass: ['error-snackbar']});
              this.router.navigate(['account', 'login']);
            }
          }
        );
    } else {
      this.router.navigate(['account', 'login']);
    }
  }

  setTokensIntoStorage(
    accessToken: string,
    refreshToken: string,
    userData: string
  ) {
    this.authService.setAccessToken(accessToken);
    this.authService.setRefreshToken(refreshToken);
    this.authService.setToken(
      JSON.stringify({
        accessToken: accessToken,
        refreshToken: refreshToken,
      })
    );
    this.authService.saveUserDataInLocalStorage(userData);
    this.authService.decodeAccessToken();
    this.setPermissionData(JSON.parse(userData));
    this.setProfilePicUrl(JSON.parse(userData));
  }

  setPermissionData(userData: any) {
    const userRoles: string[] = [];
    for(let i=0; i<userData?.roles?.length; i++) {
      if(userData?.roles[i]?.name) {
        userRoles.push(userData?.roles[i]?.name);
      }
    }
    if(userRoles.length) {
      this.authService.getUserPermissionByRole(userRoles)
        .subscribe({
          next: (data: any) => {
            if(data?.status) {
              this.authService.setUserPermissions(JSON.stringify(data?.permissions));
            }
          }
        })
    }
  }

  setProfilePicUrl(userData: any) {
    if(userData?.profilePic && userData.profilePic) {
      this.authService.getSecuredUrl(userData.profilePic)
        .subscribe({
          next: (data) => {
            if(data?.url) {
              this.authService.setProfilePicUrl(data?.url);
            }
          }
        })
    }
  }
}
